
import { UsCaV1 } from '@iabtcf/gpp/encoder/section/UsCaV1.js'; 
import { UsCoV1 } from '@iabtcf/gpp/encoder/section/UsCoV1.js'; 
import { UsCtV1 } from '@iabtcf/gpp/encoder/section/UsCtV1.js'; 
import { UsUtV1 } from '@iabtcf/gpp/encoder/section/UsUtV1.js'; 
import { UsVaV1 } from '@iabtcf/gpp/encoder/section/UsVaV1.js';


export function updateCMPColorado( consentToAll, cmpApi, consentToSharing ) {
    console.log("LayerStateColorado: updateCMP() consentToAll=" + consentToAll );

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsCoV1Field.ts

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCoV1.ts

    //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CO/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Colorado%20Privacy%20Technical%20Specification.md

    let sections = cmpApi.getApplicableSections();

      if ( sections.indexOf( UsCoV1.ID) == -1 ) {
        sections.push( UsCoV1.ID )
        cmpApi.setApplicableSections(sections);
      }

      if ( consentToAll ) {
        cmpApi.setFieldValue(UsCoV1.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
      }

    cmpApi.setFieldValue(UsCoV1.NAME, 'Version', 1);
    cmpApi.setFieldValue(UsCoV1.NAME, 'SharingNotice', 1);  // 1 = notice given
    cmpApi.setFieldValue(UsCoV1.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
    cmpApi.setFieldValue(UsCoV1.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
    cmpApi.setFieldValue(UsCoV1.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
    cmpApi.setFieldValue(UsCoV1.NAME, 'TargetedAdvertisingOptOut', consentToSharing ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
    // cmpApi.setFieldValue(UsCoV1.NAME, 'SensitiveDataProcessing', this.sensitiveDataConsents);
    cmpApi.setFieldValue(UsCoV1.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
    cmpApi.setFieldValue(UsCoV1.NAME, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
    cmpApi.setFieldValue(UsCoV1.NAME, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
    cmpApi.setFieldValue(UsCoV1.NAME, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

    // todo: get GPC flag from browser and set GPC flag here...

    cmpApi.setFieldValue(UsCoV1.NAME, 'GpcSegmentType', 1);
    cmpApi.setFieldValue(UsCoV1.NAME, 'GpcSegmentIncluded', 0);
    }

    export function updateCMPCalifornia( consentToAll, cmpApi, consentToSharing ) {
        console.log("LayerStateCalifornia: updateCMP() consentToAll=" + consentToAll );
    
        //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsCaV1Field.ts
    
        //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCaV1.ts
    
        //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20California%20Privacy%20Technical%20Specification.md
      
    
        let sections = cmpApi.getApplicableSections();
    
          if ( sections.indexOf( UsCaV1.ID ) == -1 ) {
            sections.push( UsCaV1.ID );
            cmpApi.setApplicableSections(sections);
          }
    
          if ( consentToAll ) {
            cmpApi.setFieldValue(UsCaV1.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
          }
    
          cmpApi.setFieldValue(UsCaV1.NAME, 'Version', 1);
          cmpApi.setFieldValue(UsCaV1.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
          cmpApi.setFieldValue(UsCaV1.NAME, 'SharingOptOutNotice', 1);  // 1 = notice given
          cmpApi.setFieldValue(UsCaV1.NAME, 'SensitiveDataLimitUseNotice', 1);  // 1 = notice given
    
          cmpApi.setFieldValue(UsCaV1.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
          cmpApi.setFieldValue(UsCaV1.NAME, 'SharingOptOut', consentToSharing ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
    
          cmpApi.setFieldValue(UsCaV1.NAME, 'KnownChildSensitiveDataConsents', [0,0]); // 0 = not applicable
          cmpApi.setFieldValue(UsCaV1.NAME, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
          cmpApi.setFieldValue(UsCaV1.NAME, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
          cmpApi.setFieldValue(UsCaV1.NAME, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)
    
          // todo: get GPC flag from browser and set GPC flag here...
    
          cmpApi.setFieldValue(UsCaV1.NAME, 'GpcSegmentType', 1);
          cmpApi.setFieldValue(UsCaV1.NAME, 'GpcSegmentIncluded', 0);
          }
    


export function updateCMPConnecticut( consentToAll, cmpApi, consentToSharing ) {
    console.log("LayerStateConnecticut: updateCMP() consentToAll=" + consentToAll );

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsCtV1Field.ts

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCtV1.ts

    //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CT/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Connecticut%20Privacy%20Technical%20Specification.md

    let sections = cmpApi.getApplicableSections();

      if ( sections.indexOf( UsCtV1.ID) == -1 ) {
        sections.push( UsCtV1.ID );
        cmpApi.setApplicableSections(sections);
      }

      if ( consentToAll ) {
        cmpApi.setFieldValue(UsCtV1.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
      }

    cmpApi.setFieldValue(UsCtV1.NAME, 'Version', 1);
    cmpApi.setFieldValue(UsCtV1.NAME, 'SharingNotice', 1);  // 1 = notice given
    cmpApi.setFieldValue(UsCtV1.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
    cmpApi.setFieldValue(UsCtV1.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
    cmpApi.setFieldValue(UsCtV1.NAME, 'SaleOptOut', this.consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
    cmpApi.setFieldValue(UsCtV1.NAME, 'TargetedAdvertisingOptOut', this.consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
    // cmpApi.setFieldValue(UsCtV1.NAME, 'SensitiveDataProcessing', this.sensitiveDataConsents);
    cmpApi.setFieldValue(UsCtV1.NAME, 'KnownChildSensitiveDataConsents', [0,0,0]); // 0 = not applicable
    cmpApi.setFieldValue(UsCtV1.NAME, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
    cmpApi.setFieldValue(UsCtV1.NAME, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
    cmpApi.setFieldValue(UsCtV1.NAME, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

    // todo: get GPC flag from browser and set GPC flag here...

    cmpApi.setFieldValue(UsCtV1.NAME, 'GpcSegmentType', 1);
    cmpApi.setFieldValue(UsCtV1.NAME, 'GpcSegmentIncluded', 0);
    }


export function updateCMPUtah( consentToAll, cmpApi, consentToSharing ) {
    console.log("LayerStateUtah: updateCMP() consentToAll=" + consentToAll );

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsUtV1Field.ts

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsUtV1.ts

    //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CT/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Utah%20Privacy%20Technical%20Specification.md

    let sections = cmpApi.getApplicableSections();

      if ( sections.indexOf( UsUtV1.ID) == -1 ) {
        sections.push( UsUtV1.ID );
        cmpApi.setApplicableSections(sections);
      }

      if ( consentToAll ) {
        this.cmpApi.setFieldValue(UsUtV1.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
      }

    this.cmpApi.setFieldValue(UsUtV1.NAME, 'Version', 1);
    cmpApi.setFieldValue(UsUtV1.NAME, 'SharingNotice', 1);  // 1 = notice given
    cmpApi.setFieldValue(UsUtV1.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
    cmpApi.setFieldValue(UsUtV1.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
    cmpApi.setFieldValue(UsUtV1.NAME, 'SaleOptOut', this.consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
    cmpApi.setFieldValue(UsUtV1.NAME, 'TargetedAdvertisingOptOut', this.consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
    // cmpApi.setFieldValue(UsUtV1.NAME, 'SensitiveDataProcessing', this.sensitiveDataConsents);
    cmpApi.setFieldValue(UsUtV1.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
    cmpApi.setFieldValue(UsUtV1.NAME, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
    cmpApi.setFieldValue(UsUtV1.NAME, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
    cmpApi.setFieldValue(UsUtV1.NAME, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)
    
    // no GPC fields for Utah

    }

    export function updateCMPVirginia( consentToAll, cmpApi, consentToSharing ) {
        console.log("LayerStateVirginia: updateCMP() consentToAll=" + consentToAll );
    
        //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsVaV1Field.ts
    
        //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsVaV1.ts
    
        //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
    
        let sections = cmpApi.getApplicableSections();
    
          if ( sections.indexOf( UsVaV1.ID) == -1 ) {
            sections.push( UsVaV1.ID );
            cmpApi.setApplicableSections(sections);
          }
    
          if ( consentToAll ) {
            cmpApi.setFieldValue(UsVaV1.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
          }
    
        cmpApi.setFieldValue(UsVaV1.NAME, 'Version', 1);
        cmpApi.setFieldValue(UsVaV1.NAME, 'SharingNotice', 1);  // 1 = notice given
        cmpApi.setFieldValue(UsVaV1.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
        cmpApi.setFieldValue(UsVaV1.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
        cmpApi.setFieldValue(UsVaV1.NAME, 'SaleOptOut', this.consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
        cmpApi.setFieldValue(UsVaV1.NAME, 'TargetedAdvertisingOptOut', this.consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
        // cmpApi.setFieldValue(UsVaV1.NAME, 'SensitiveDataProcessing', this.sensitiveDataConsents);
        cmpApi.setFieldValue(UsVaV1.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
        cmpApi.setFieldValue(UsVaV1.NAME, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
        cmpApi.setFieldValue(UsVaV1.NAME, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
        cmpApi.setFieldValue(UsVaV1.NAME, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)
    
        // no GPC fields for Virginia
      }